import jQuery from 'jquery';

const $ = jQuery;

/**
 * Removes the `refresh` query param from directory profile URLs.
 *
 * @since 1.0.3
 * @returns {void}
 */
document.addEventListener('DOMContentLoaded', () => {
	const url = new URL(window.location.href);

	if (!url.searchParams.has('refresh')) {
		return;
	}

	url.searchParams.delete('refresh');

	const next =
		url.pathname +
		(url.searchParams.toString() ? `?${url.searchParams.toString()}` : '') +
		url.hash;

	window.history.replaceState({}, '', next);
});

/**
 * Modifies the navigation menu by adding the current page as a new list item,
 * and if applicable, adding sublist items for any sections within a directory profile.
 * 
 * - Checks if the profile page and necessary DOM elements are available.
 * - Adds a new list item with a link to the current page.
 * - If the 'directoryProfileContainer' exists, it grabs all h2 elements within it and creates
 *   a sublist with links to each section of the profile.
 * - Updates the sidebar navigation if the SecondaryNav function is available.
 * - Triggers the 'navChanged' event to recalculate navigation layout if needed.
 * 
 * @since 1.0.0
 * @returns {void}
 */
document.addEventListener('DOMContentLoaded', () => {
	// Get the profile body element
	const profileBody = document.getElementById('directoryProfileBody');
	if (!profileBody) return; // Exit if the profile body is not found
	
	// Get the navigation section within the profile body
	const nav = profileBody.querySelector('nav.sidebar--page-nav');
	if (!nav) return; // Exit if the navigation section is not found

	// Get the unordered list (<ul>) inside the navigation
	const ul = nav.querySelector('ul');
	if (!ul) return; // Exit if no <ul> is found
	
	// Get the first item with the class 'page-nav-home' to insert the new item after
	const firstItem = ul.querySelector('.page-nav-home');
	
	// Get the page title element (h1)
	const pageTitle = document.getElementById('ariaPageTitleLabel');
	if (!pageTitle) return; // Exit if the page title element is not found
	
	// Get the current URL (excluding any hash that might exist)
	const currentUrl = window.location.origin + window.location.pathname;

	// Create new list item (<li>) for the current page
	const li = document.createElement('li');
	const link = document.createElement('a');
	
	// Add classes to the list item for styling
	li.classList.add('menu-item', 'current-menu-item');
	
	// Set the href and text for the new link
	link.href = currentUrl;
	link.textContent = pageTitle.textContent.trim();
	link.classList.add('current');
	
	// Append the link to the list item
	li.appendChild(link);

	// Insert the new <li> based on the presence of .page-nav-home
	if (firstItem) {
		// If .page-nav-home exists, insert the new item after it
		firstItem.insertAdjacentElement('afterend', li);
	} else {
		// Otherwise, prepend it to the beginning of the list
		li.classList.add('page-nav-home');
		ul.prepend(li);
	}
	
	// Check if 'directoryProfileContainer' exists and contains h2 elements
	const directoryContainer = document.getElementById('directoryProfileContainer');
	if (directoryContainer) {
		// Get all direct child <h2> elements
		const headings = directoryContainer.querySelectorAll(':scope > h2'); // Select only direct child h2s
		if (headings.length > 0) {
			// Create the sublist <ul> if h2 elements are found
			const sublist = document.createElement('ul');
			sublist.classList.add('sub-menu');
			
			// Iterate over the h2 elements and create <li> items with links
			headings.forEach(h2 => {
				if (!h2.id) return; // Skip h2 elements without an ID (cannot link to them)
	
				const subLi = document.createElement('li');
				const subLink = document.createElement('a');
				
				// Set the href and text for each sublist item link
				subLink.href = `${currentUrl}#${h2.id}`;
				subLink.textContent = h2.textContent.trim();
				
				// Append the link to the <li> and then the <li> to the sublist
				subLi.appendChild(subLink);
				subLi.classList.add('menu-item');
				sublist.appendChild(subLi);
			});
			
			// Append the sublist to the new <li> and mark it as a menu item with children
			li.appendChild(sublist);
			li.classList.add('menu-item-has-children');
		}
	}
	
	// Check if 'SecondaryNav' function is available and invoke it if so
	if ($.isFunction($.fn.SecondaryNav)) {
		$('.sidebar--page-nav').SecondaryNav();
	}
	
	// Trigger the 'navChanged' event if jQuery is available and the trigger function exists
	if (typeof $ === 'function' && typeof $(document).trigger === 'function') {
		try {
			$(document).trigger('navChanged');
		} catch (error) {
			console.warn('navChanged event not triggered:', error);
		}
	}
});
